(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/product-form-bundler
 * -----------------------------------------------------------------------------
 * @version 0.0.2
 * @overview Bundles multiple product form contents into one submission.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * @requires @cam/product-form
 * -----------------------------------------------------------------------------
*/ if (customElements.get("product-form-bundler") === undefined) {
    class ProductFormBundler extends HTMLElement {
        constructor(){
            super();
            this.productForms = this.querySelectorAll("product-form");
            this.submitButton = this.querySelector('[name="bundle"]');
            this.redirectOnSubmit = this.querySelector('[name="return_to"]')?.value;
        }
        connectedCallback() {
            this.productForms.forEach((productForm)=>productForm.idInput.addEventListener("change", this.formChange.bind(this)));
            this.submitButton.addEventListener("click", this.addBundle.bind(this));
        }
        disconnectedCallback() {
            this.productForms.forEach((productForm)=>productForm.idInput.addEventListener("change", this.formChange.bind(this)));
            this.submitButton.removeEventListener("click", this.addBundle.bind(this));
        }
        formChange() {
            Array.from(this.productForms).filter((productForm)=>productForm.submitButton.attributes.disabled).length ? this.unavailable() : this.available();
        }
        unavailable() {
            this.submitButton.setAttribute("disabled", true);
            this.submitButton.textContent = Array.from(this.productForms).filter((productForm)=>productForm.submitButton.innerText === window.language.soldOut).length ? window.language.soldOut : window.language.unavailable;
        }
        available() {
            this.submitButton.removeAttribute("disabled");
            this.submitButton.textContent = window.language.addToCart;
        }
        serializeForm(form) {
            const output = {};
            const input = new FormData(form);
            const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
            for (const key of input.keys())if (regex.test(key)) {
                output.properties = output.properties || {};
                output.properties[regex.exec(key)[2]] = input.get(key);
            } else output[key] = input.get(key);
            return JSON.stringify(output);
        }
        bundleItems() {
            let items = [];
            let bundleDate = Date.now();
            const invalidForms = Array.from(this.productForms).filter((productForm)=>productForm.querySelector("form").reportValidity() === false).length;
            if (invalidForms !== 0) return false;
            this.productForms.forEach((form, index)=>{
                const formData = JSON.parse(this.serializeForm(form.querySelector("form")));
                let item = {
                    id: formData.id,
                    quantity: formData.quantity
                };
                item.properties = {};
                if (formData.properties) Object.assign(item.properties, formData.properties);
                item.properties["_bundle_id"] = bundleDate;
                items.push(item);
            });
            items.reverse();
            return items;
        }
        addBundle() {
            this.loadingState(true);
            let items = this.bundleItems();
            if (!items) {
                this.updateErrorMessage();
                return;
            }
            this.submitButton.setAttribute("disabled", true);
            fetch(`${routes.cart_add_url}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/javascript",
                    "X-Requested-With": "XMLHttpRequest"
                },
                body: JSON.stringify({
                    items: items
                })
            }).then((response)=>response.json()).then((response)=>{
                response.status ? this.updateErrorMessage(response.description) : document.dispatchEvent(new CustomEvent("cart:updated", {
                    detail: {
                        type: "added",
                        response: response
                    }
                }));
            }).catch((error)=>{
                console.error(error);
            }).finally(()=>{
                this.loadingState(false);
                if (this.redirectOnSubmit) window.location = this.redirectOnSubmit;
                this.submitButton.removeAttribute("disabled");
            });
        }
        loadingState(loading) {
            loading ? [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.add("loading")) : [
                this,
                document.documentElement
            ].forEach((target)=>target.classList.remove("loading"));
        }
        updateErrorMessage(errorMessage = false) {
            // TODO: response doesn't always exist
            // if (errorMessage) document.dispatchEvent(new CustomEvent('cart:error', { detail: { response } }));
            this.loadingState(false);
            this.errorMessageWrapper = this.querySelector(".error-message");
            if (!this.errorMessageWrapper) return;
            this.errorMessageContent = this.errorMessageContent || this.errorMessageWrapper.querySelector(".error-message-content");
            this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
            if (errorMessage) this.errorMessageContent.textContent = errorMessage;
        }
    }
    customElements.define("product-form-bundler", ProductFormBundler);
}



})();
